import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { usePermissions } from '../contexts/permissionsContext';
import useAuth from '../hooks/useAuth';

/**
 * Ao mudar de rota (pathname), atualiza permissões em background (sem limpar Cache Storage).
 * Sem SimpleBackdrop — Sidebar/TopBar permanecem estáveis.
 * @returns {null}
 */
const RouteChangeLoading = () => {
    const { pathname } = useLocation();
    const { refreshPermissions } = usePermissions();
    const { signed } = useAuth();
    const refreshPermissionsRef = useRef(refreshPermissions);
    const inFlightRef = useRef(false);
    const isFirstPathRef = useRef(true);

    refreshPermissionsRef.current = refreshPermissions;

    useEffect(() => {
        // Primeiro mount: permissões já vêm do PermissionsProvider
        if (isFirstPathRef.current) {
            isFirstPathRef.current = false;
            return undefined;
        }

        if (!signed) return undefined;
        if (inFlightRef.current) return undefined;

        inFlightRef.current = true;

        const refresh = async () => {
            try {
                await refreshPermissionsRef.current({ silent: true });
            } catch (error) {
                console.error('Erro ao atualizar permissões:', error);
            } finally {
                inFlightRef.current = false;
            }
        };

        refresh();

        return undefined;
    }, [pathname, signed]);

    return null;
};

export default RouteChangeLoading;
